module.exports = __webpack_public_path__ + "static/media/video_image3.7a8b0370.png";